import { ApolloClient, ApolloProvider, NormalizedCacheObject } from '@apollo/client';
import { ChakraProvider, CSSReset } from '@chakra-ui/react';
import { Dict } from '@chakra-ui/utils';
import React from 'react';
import { RecoilRoot } from 'recoil';

import defaultTheme from '../../chakra';
import { createApolloClient } from '../../lib/apolloClient';

interface Props {
  apolloClient?: ApolloClient<NormalizedCacheObject>;
  children: React.ReactNode;
  theme?: Dict<any>;
}

const defaultApolloClient = createApolloClient();

/**
 * Renders all context providers
 */
export function AllProviders({
  apolloClient = defaultApolloClient,
  theme = defaultTheme,
  children,
}: Props) {
  return (
    <ApolloProvider client={apolloClient}>
      <ChakraProvider theme={theme}>
        <RecoilRoot>
          <CSSReset />

          {children}
        </RecoilRoot>
      </ChakraProvider>
    </ApolloProvider>
  );
}
